module.exports = __webpack_public_path__ + "563c45e2b69113c77b92501a8d3c1e80.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-mike.png
// module id = 661
// module chunks = 0